import { render, staticRenderFns } from "./vendor.vue?vue&type=template&id=f2183cf0&scoped=true"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"
import style0 from "./vendor.vue?vue&type=style&index=0&id=f2183cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2183cf0",
  null
  
)

export default component.exports